const baseColor = 'merlin';


export const GetColor=(type,amount,transparent=100)=>{return type+"-"+baseColor+"-"+amount+(transparent>0?'/'+transparent:'')}